import { ListFieldsType, systemsListName } from "src/api/config";
import { SystemType } from "../../../types/main";

export function modifiedSystemsList(systems: ListFieldsType[typeof systemsListName][]): SystemType[] {
  let resultsObj: SystemType[] = [];

  if (systems && systems.length > 0) {
    resultsObj = systems.map((item) => ({
      id: +item.ID,
      sort_id: item.Sort_ID,
      title: item.Title,
      description: item.Description,
      url: item.IconUrl,
      externalLink: item.ExternalLink,
    }));
  }

  return resultsObj;
}
